import { Banner, Text } from '@loadsmart/miranda-react'

import { type Carrier } from '../../domain/Shipment'

function TelephoneSlashIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="24"
      height="24"
      fill="currentColor"
    >
      <path
        d="M13.0234 8.84553C12.8633 8.65067 12.6659 8.48987 12.4426 8.37262C12.2194 8.25538 11.9749 8.18407 11.7236 8.16291C11.4723 8.14175 11.2194 8.17118 10.9797 8.24944C10.74 8.32771 10.5184 8.45323 10.328 8.61859C10.1376 8.78394 9.98233 8.98578 9.87128 9.21217C9.76024 9.43857 9.6957 9.68492 9.68148 9.93668C9.66726 10.1884 9.70364 10.4405 9.78849 10.678C9.87333 10.9154 10.0049 11.1335 10.1755 11.3192L13.8306 15.5371C11.387 16.6143 9.1485 18.1065 7.21427 19.9477C3.7657 23.2444 3.32718 28.2106 6.15298 32.0338C6.44002 32.4166 6.81062 32.7288 7.23656 32.9467C7.6625 33.1646 8.13255 33.2825 8.61092 33.2913C8.99357 33.3002 9.37458 33.2385 9.73487 33.1093L17.4837 30.5568L17.5551 30.5317C18.0448 30.3483 18.4808 30.0454 18.8236 29.6505C19.1663 29.2556 19.4048 28.7813 19.5174 28.2706L20.4699 24.0112C20.663 23.9559 20.8607 23.9069 21.0582 23.8673L34.6847 39.5636C34.8447 39.7585 35.0422 39.9193 35.2654 40.0366C35.4887 40.1538 35.7332 40.2251 35.9844 40.2463C36.2357 40.2674 36.4887 40.238 36.7284 40.1597C36.9681 40.0815 37.1897 39.956 37.3801 39.7906C37.5704 39.6252 37.7257 39.4234 37.8368 39.197C37.9478 38.9706 38.0124 38.7243 38.0266 38.4725C38.0408 38.2207 38.0044 37.9687 37.9196 37.7312C37.8347 37.4938 37.7031 37.2757 37.5326 37.09L13.0234 8.84553ZM16.8731 22.8301L15.9267 27.099L8.92902 29.4012C7.5386 27.1929 7.87419 24.5394 9.82595 22.6745C11.7254 20.8571 13.9794 19.4509 16.4469 18.544L18.3888 20.7743C18.0068 20.9924 17.6746 21.2879 17.4136 21.6419C17.1526 21.9959 16.9685 22.4007 16.8731 22.8301ZM41.181 32.8196C40.7268 33.3785 40.0937 33.7635 39.3885 33.9096C38.9193 34.0084 38.4301 33.9248 38.0203 33.6759C37.6105 33.427 37.3108 33.0314 37.1822 32.5696C37.0535 32.1077 37.1055 31.6141 37.3276 31.1892C37.5497 30.7643 37.9252 30.4399 38.3779 30.2818C40.0332 28.1066 39.8667 25.3285 37.9403 23.3124C34.4609 19.6694 29.6701 17.5331 24.4712 17.2953C23.9711 17.2783 23.4981 17.0633 23.1565 16.6976C22.8149 16.3319 22.6325 15.8455 22.6495 15.3453C22.6665 14.8452 22.8815 14.3722 23.2472 14.0306C23.6129 13.689 24.0993 13.5066 24.5995 13.5236L24.6419 13.5246C30.8213 13.8019 36.5134 16.3503 40.6687 20.7008C43.9637 24.1571 44.176 29.1382 41.1826 32.8212L41.181 32.8196Z"
        fill="black"
      />
    </svg>
  )
}

export function NoCallsNeededBanner({ shipmentCarrier }: { shipmentCarrier: Carrier }) {
  return (
    <Banner variant="success">
      <Banner.Icon>
        <TelephoneSlashIcon />
      </Banner.Icon>
      <Banner.Title>No calls needed!</Banner.Title>
      <Banner.Description>
        We'll send all your info to the facility automatically:
        <br />
        <Text variant="body-md-bold">
          {shipmentCarrier.name}
          <br /> MC {shipmentCarrier.mc} • DOT {shipmentCarrier.dot} {shipmentCarrier.email}
        </Text>
      </Banner.Description>
    </Banner>
  )
}
